module.exports = __webpack_public_path__ + "./docs/img/node.d846746b2142d77cb17e4d19aa0084dc.svg";